import styled from 'styled-components';

export const Information = styled.div`
  width: 100%;
  background-color: ${({ $bgColor, theme }) =>
    ($bgColor === 'amber' && theme.palette.alertDark) ||
    ($bgColor === 'black' && theme.palette.footerBlack)};

  color: ${({ $bgColor, theme }) =>
    ($bgColor === 'amber' && theme.palette.standardText) ||
    ($bgColor === 'black' && theme.palette.white)};
  padding: ${({ theme }) => theme.spacing.small} 0;

  a {
    color: ${({ $bgColor, theme }) =>
      ($bgColor === 'amber' && theme.palette.standardText) ||
      ($bgColor === 'black' && theme.palette.white)};
  }
  a:focus,
  a:hover {
    color: ${({ $bgColor, theme }) =>
      ($bgColor === 'amber' && theme.palette.standardText) ||
      ($bgColor === 'black' && theme.palette.linkHoverOnDarkBG)};
  }
  p:last-child {
    margin-bottom: 0;
  }
`;
